import qs from "qs";
import api from "@/api";
/**
 * @param {Object} params - 线索列表数据
 */
export function GetMerchantsList(params = {}) {
    return new Promise((resolve, reject) => {
        api.get(`/merchants?${qs.stringify(params, {
            arrayFormat: "repeat",
        })}`).then(res => {
            if (res.status === 200 || res.status === 206) {
                resolve(res)
            }
        }).catch(err => {
            reject(err)
        })
    })
}


/**
 * @param {Object} params - 线索列表筛选数据
 */
export function GetMerchantsListFilter(params = {}) {
    return new Promise((resolve, reject) => {
        api.get(`/merchants/filters?${qs.stringify(params, {
            arrayFormat: "repeat",
        })}`).then(res => {
            if (res.status === 200) {
                resolve(res)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * 获取跟进状态选单
 */
export function GetFollowUpStatuses() {
    return new Promise((resolve, reject) => {
        api.get(`/merchants/follow_up_statuses/selections`).then(res => {
            if (res.status === 200) {
                resolve(res)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * 获取途径选单
 */
export function GetMerchantsSources() {
    return new Promise((resolve, reject) => {
        api.get(`/merchants/sources`).then(res => {
            if (res.status === 200) {
                resolve(res)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * 获取类型选单
 */
 export function GetMerchantsType() {
    return new Promise((resolve, reject) => {
        api.get(`/merchants/types/selections`).then(res => {
            if (res.status === 200 || res.status === 206) {
                resolve(res)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * 获取类型选单
 */
 export function GetMerchantsOwner() {
    return new Promise((resolve, reject) => {
        api.get(`/merchants/owners/selections`).then(res => {
            if (res.status === 200) {
                resolve(res)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * 获取类型选单
 */
 export function GetPromotionCompany() {
    return new Promise((resolve, reject) => {
        api.get(`/companies/all`).then(res => {
            if (res.status === 200) {
                resolve(res)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * 获取公司类型选单
 */
 export function GetCompanyTypes() {
    return new Promise((resolve, reject) => {
        api.get(`/merchants/company_types/selections`).then(res => {
            if (res.status === 200) {
                resolve(res)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * 获取招商品牌选单
 */
 export function GetBrandsSelection() {
    return new Promise((resolve, reject) => {
        api.get(`/merchants/brands/selections`).then(res => {
            if (res.status === 200) {
                resolve(res)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

// /merchants/sources

/**
 * 获取阶段选单
 */
export function GetStates(params = {}) {
    return new Promise((resolve, reject) => {
        api.get(`/merchants/stages?${qs.stringify(params, {
            arrayFormat: "repeat",
        })}`).then(res => {
            if (res.status === 200 || res.status === 206) {
                resolve(res)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * 获取招商小程序码
 */
export function GetMerchantsQrCode() {
    return new Promise((resolve, reject) => {
        api.get(`/merchants/qr_code_url`).then(res => {
            if (res.status === 200 || res.status === 206) {
                resolve(res)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * 设置用户置顶，星标
 */
export function PutMerchantsStarSwitch(id=null) {
    return new Promise((resolve, reject) => {
        api.put(`/merchants/${id}/star/switch`).then(res => {
            if (res.status === 201 || res.status === 204) {
                resolve(res)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * 设置跟进记录置顶
 */
export function PutMerchantsLogStarSwitch(id=null, followUpId=null) {
    return new Promise((resolve, reject) => {
        api.put(`/merchants/${id}/follow_ups/${followUpId}/star/switch`).then(res => {
            if (res.status === 201 || res.status === 204) {
                resolve(res)
            }
        }).catch(err => {
            reject(err)
        })
    })
}





// /merchants/follow_up_statuses/selections